function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

import mapObject from 'map-obj';
import camelCase from 'camelcase';
import QuickLru from 'quick-lru';

var has = function has(array, key) {
  return array.some(function (element) {
    if (typeof element === 'string') {
      return element === key;
    }

    element.lastIndex = 0;
    return element.test(key);
  });
};

var cache = new QuickLru({
  maxSize: 100000
}); // Reproduces behavior from `map-obj`.

var isObject = function isObject(value) {
  return _typeof(value) === 'object' && value !== null && !(value instanceof RegExp) && !(value instanceof Error) && !(value instanceof Date);
};

var transform = function transform(input) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (!isObject(input)) {
    return input;
  }

  var exclude = options.exclude,
      _options$pascalCase = options.pascalCase,
      pascalCase = _options$pascalCase === void 0 ? false : _options$pascalCase,
      stopPaths = options.stopPaths,
      _options$deep = options.deep,
      deep = _options$deep === void 0 ? false : _options$deep,
      _options$preserveCons = options.preserveConsecutiveUppercase,
      preserveConsecutiveUppercase = _options$preserveCons === void 0 ? false : _options$preserveCons;
  var stopPathsSet = new Set(stopPaths);

  var makeMapper = function makeMapper(parentPath) {
    return function (key, value) {
      if (deep && isObject(value)) {
        var path = parentPath === undefined ? key : "".concat(parentPath, ".").concat(key);

        if (!stopPathsSet.has(path)) {
          value = mapObject(value, makeMapper(path));
        }
      }

      if (!(exclude && has(exclude, key))) {
        var cacheKey = pascalCase ? "".concat(key, "_") : key;

        if (cache.has(cacheKey)) {
          key = cache.get(cacheKey);
        } else {
          var returnValue = camelCase(key, {
            pascalCase: pascalCase,
            locale: false,
            preserveConsecutiveUppercase: preserveConsecutiveUppercase
          });

          if (key.length < 100) {
            // Prevent abuse
            cache.set(cacheKey, returnValue);
          }

          key = returnValue;
        }
      }

      return [key, value];
    };
  };

  return mapObject(input, makeMapper(undefined));
};

export default function camelcaseKeys(input, options) {
  if (Array.isArray(input)) {
    return Object.keys(input).map(function (key) {
      return transform(input[key], options);
    });
  }

  return transform(input, options);
}